(function () {
  var d = document, h = d.documentElement, w = window;
  var reduce = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var design = h.classList.contains('shopify-design-mode') || !!(w.Shopify && w.Shopify.designMode);
  var done = new WeakSet(), grainURL = null, io = null, vio = null, hdr = null, ticking = false;
  var parallax = [], sweeps = [], marquees = [], heroV = null, bar = null, time = null, vel = 0, lastY = w.scrollY || 0;
  var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';

  function all(r, s) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function once(el) { if (done.has(el)) return false; done.add(el); return true; }
  function play(v) { v.muted = true; v.defaultMuted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function grain() {
    if (grainURL) return grainURL;
    var c = d.createElement('canvas'); c.width = c.height = 140;
    var x = c.getContext('2d'), im = x.createImageData(140, 140);
    for (var i = 0; i < im.data.length; i += 4) { var v = Math.random() * 255; im.data[i] = im.data[i + 1] = im.data[i + 2] = v; im.data[i + 3] = 255; }
    x.putImageData(im, 0, 0); grainURL = c.toDataURL('image/png'); return grainURL;
  }
  function introDelay() { var c = d.querySelector('.gl-curtain'); return c && getComputedStyle(c).display !== 'none' ? 1300 : 150; }

  function intro(r) {
    var delay = introDelay();
    if (!reduce && !design) {
      all(r, '[data-gl-rise]').forEach(function (el) { if (!once(el)) return; el.animate([{ transform: 'translateY(108%)' }, { transform: 'translateY(0)' }], { duration: 1400, delay: delay + 140 * (+el.getAttribute('data-gl-rise') || 0), easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' }); });
      all(r, '[data-gl-fade]').forEach(function (el) { if (!once(el)) return; el.animate([{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 1100, delay: delay + 380 + 130 * (+el.getAttribute('data-gl-fade') || 0), easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' }); });
      all(r, '[data-gl-kenburns]').forEach(function (el) { if (!once(el)) return; el.animate([{ transform: 'scale(1.15)' }, { transform: 'scale(1)' }], { duration: 3400, delay: Math.max(0, delay - 500), easing: 'cubic-bezier(.2,.6,.2,1)', fill: 'backwards' }); });
    }
    h.classList.add('gl-go');
  }

  function header(el) {
    var menu = d.querySelector('[data-gl-menu]'), btn = el.querySelector('[data-gl-menu-btn]'), badge = el.querySelector('[data-gl-cart-count]'), cart = el.querySelector('[data-gl-cart]');
    var home = !!d.querySelector('#MainContent[data-template="index"]'), hidden = false;
    function setMenu(o) {
      if (!menu) return;
      menu.classList.toggle('is-open', o); el.classList.toggle('is-menu', o);
      if (btn) { btn.textContent = btn.getAttribute(o ? 'data-close' : 'data-open'); btn.setAttribute('aria-expanded', o ? 'true' : 'false'); }
      h.style.overflow = o ? 'hidden' : '';
    }
    if (btn) btn.addEventListener('click', function () { setMenu(!menu.classList.contains('is-open')); });
    if (menu) all(menu, 'a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    if (cart) cart.addEventListener('click', function (e) {
      var c = d.querySelector('cart-drawer-component'), td = c && c.closest('theme-drawer');
      if (td && typeof td.open === 'function') { e.preventDefault(); setMenu(false); td.open(); }
    });
    function setCount(n) {
      if (!badge || n == null) return;
      var old = parseInt(badge.textContent, 10) || 0; badge.textContent = n;
      if (n > old && !reduce && badge.animate) badge.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.5)' }, { transform: 'scale(1)' }], { duration: 560, easing: 'cubic-bezier(.3,1.6,.5,1)' });
    }
    function refresh() { fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {}); }
    try {
      import('@shopify/events').then(function (m) {
        if (!m || !m.StandardEvents) return;
        d.addEventListener(m.StandardEvents.cartLinesUpdate, function (ev) {
          if (!ev.promise) { setTimeout(refresh, 800); return; }
          ev.promise.then(function (r) { var n = r && r.cart && r.cart.totalQuantity; if (n == null && r && r.detail) n = r.detail.itemCount; if (n != null) setCount(n); else refresh(); }).catch(function () {});
        });
      }).catch(function () {});
    } catch (e) {}
    d.addEventListener('submit', function (e) { var f = e.target; if (f && f.getAttribute && f.getAttribute('data-type') === 'add-to-cart-form') setTimeout(refresh, 1500); }, true);
    w.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    hdr = { update: function (y, dy) {
      el.classList.toggle('is-solid', !home || y > 30);
      if (y < 220) hidden = false; else if (dy > 6) hidden = true; else if (dy < -6) hidden = false;
      el.classList.toggle('is-hidden', hidden && !el.classList.contains('is-menu'));
    } };
  }

  function glazes(r) {
    var items = all(r, '[data-gl-glaze]'), img = r.querySelector('[data-gl-viewer-img]'), num = r.querySelector('[data-gl-viewer-num]'), name = r.querySelector('[data-gl-viewer-name]');
    var reset = r.querySelector('[data-gl-viewer-reset]'), cta = r.querySelector('[data-gl-glaze-cta]'), viewer = r.querySelector('[data-gl-viewer]');
    var allName = r.getAttribute('data-all') || '', zoom = 2.5, cur = -1, pause = 0, iv = null, first = null, on = false;
    var auto = r.getAttribute('data-auto') !== 'false' && !reduce && !design;
    var vmap = {}; try { vmap = JSON.parse(r.getAttribute('data-variants') || '{}'); } catch (e) {}
    var base = cta ? cta.getAttribute('href') : '';
    function set(i, manual) {
      cur = i; r.classList.toggle('is-picked', i >= 0);
      items.forEach(function (el, k) {
        el.classList.toggle('is-on', k === i); el.setAttribute('aria-pressed', k === i ? 'true' : 'false');
        var ln = el.querySelector('[data-gl-glaze-line]'); if (!ln || !ln.animate) return;
        ln.getAnimations().forEach(function (a) { a.cancel(); });
        if (k === i) { var fast = manual || !auto; ln.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: fast || reduce ? 500 : 4200, easing: fast ? 'cubic-bezier(.2,.7,.2,1)' : 'linear', fill: 'forwards' }); }
      });
      if (!img) return;
      if (i < 0) { img.style.transform = 'translate(0,0) scale(1)'; if (num) num.textContent = '\u2014'; if (name) name.textContent = allName; if (cta) cta.setAttribute('href', base); return; }
      var el = items[i], fx = (parseFloat(el.getAttribute('data-x')) || 50) / 100, fy = (parseFloat(el.getAttribute('data-y')) || 50) / 100;
      var tx = Math.min(0, Math.max((1 - zoom) * 100, 50 - fx * zoom * 100)), ty = Math.min(0, Math.max((1 - zoom) * 100, 50 - fy * zoom * 100));
      img.style.transform = 'translate(' + tx.toFixed(2) + '%,' + ty.toFixed(2) + '%) scale(' + zoom + ')';
      if (num) num.textContent = (i < 9 ? '0' : '') + (i + 1);
      if (name) name.textContent = el.getAttribute('data-name');
      var vid = vmap[el.getAttribute('data-name')];
      if (cta) cta.setAttribute('href', vid ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vid : base);
    }
    function tick() { if (Date.now() < pause) return; set((cur + 1) % items.length, false); }
    function start() { if (on || !auto || !items.length) return; on = true; first = setTimeout(function () { tick(); iv = setInterval(tick, 4200); }, 900); }
    function stop() { clearTimeout(first); clearInterval(iv); on = false; }
    items.forEach(function (el, k) { el.addEventListener('click', function () { pause = Date.now() + 12000; set(k, true); }); });
    if (reset) reset.addEventListener('click', function () { pause = Date.now() + 12000; set(-1, true); });
    if (viewer && 'IntersectionObserver' in w) new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) start(); else stop(); }); }, { threshold: 0.15 }).observe(viewer);
  }

  function onScroll() {
    var y = w.scrollY || h.scrollTop || 0, dy = y - lastY, vh = w.innerHeight; lastY = y;
    vel = Math.min(5, vel + Math.abs(dy) / 45);
    if (hdr) hdr.update(y, dy);
    parallax.forEach(function (el) {
      var p = el.parentElement; if (!p) return;
      var r = p.getBoundingClientRect(); if (r.bottom < -200 || r.top > vh + 200) return;
      var f = parseFloat(el.getAttribute('data-gl-parallax')) || 0.1;
      el.style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - vh / 2) * -f).toFixed(1) + 'px,0)';
    });
    sweeps.forEach(function (el) {
      var r = el.getBoundingClientRect(), p = Math.max(0, Math.min(1, (vh * 0.85 - r.top) / (r.height + vh * 0.3))), a = p * 114 - 8;
      el.style.backgroundImage = 'linear-gradient(180deg,#2A1F23 0%,#2A1F23 ' + a.toFixed(1) + '%,rgba(42,31,35,.2) ' + (a + 10).toFixed(1) + '%,rgba(42,31,35,.2) 100%)';
    });
  }

  function frame() {
    if (vel > 0.002) { vel *= 0.93; marquees.forEach(function (m) { var a = m.getAnimations ? m.getAnimations()[0] : null; if (a) a.playbackRate = 1 + vel; }); }
    if (heroV && heroV.duration) {
      if (bar) bar.style.transform = 'scaleX(' + (heroV.currentTime / heroV.duration).toFixed(4) + ')';
      if (time) { var t = '00:' + String(Math.floor(heroV.currentTime)).padStart(2, '0'); if (time.textContent !== t) time.textContent = t; }
    }
    requestAnimationFrame(frame);
  }

  function init(r) {
    r = r || d;
    all(r, '[data-gl-grain]').forEach(function (el) { el.style.backgroundImage = 'url(' + grain() + ')'; });
    all(r, '[data-gl-header]').forEach(function (el) { if (once(el)) header(el); });
    intro(r);
    all(r, '[data-gl-reveal]').forEach(function (el) { if (!once(el)) return; if (reduce || design || !io) { el.classList.add('is-in'); return; } io.observe(el); });
    all(r, 'video[data-gl-autoplay]').forEach(function (v) { if (!once(v)) return; v.muted = true; v.loop = true; v.playsInline = true; if (vio) vio.observe(v); else play(v); });
    all(r, '[data-gl-hoverplay]').forEach(function (t) {
      if (!once(t)) return; var v = t.querySelector('video'); if (!v) return; v.muted = true;
      t.addEventListener('mouseenter', function () { clearTimeout(v._t); play(v); t.classList.add('is-playing'); });
      t.addEventListener('mouseleave', function () { t.classList.remove('is-playing'); clearTimeout(v._t); v._t = setTimeout(function () { v.pause(); }, 700); });
    });
    all(r, '[data-gl-marquee]').forEach(function (el) { if (once(el) && !reduce) marquees.push(el); });
    all(r, '[data-gl-glazes]').forEach(function (el) { if (once(el)) glazes(el); });
    parallax = reduce ? [] : all(d, '[data-gl-parallax]');
    sweeps = reduce ? [] : all(d, '[data-gl-sweep]');
    sweeps.forEach(function (el) { el.style.color = 'transparent'; el.style.webkitBackgroundClip = 'text'; el.style.backgroundClip = 'text'; });
    heroV = d.querySelector('[data-gl-hero-video]'); bar = d.querySelector('[data-gl-video-progress]'); time = d.querySelector('[data-gl-video-time]');
    onScroll();
  }

  if ('IntersectionObserver' in w) {
    io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); e.target.classList.add('is-in'); } }); }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    vio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) play(e.target); else e.target.pause(); }); }, { threshold: 0.15 });
  }
  w.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; onScroll(); }); }, { passive: true });
  w.addEventListener('resize', onScroll);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  function boot() { init(d); requestAnimationFrame(frame); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
